import {useState} from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";
import {useTranslation} from "react-i18next";
import {DialogCloseCause} from "../common/Enums";
import {UserPropertyProps} from "./UserProperty";

/**
 * The owner should handle the OnClose event. The owner is responsible for closing the dialog.
 */
type OnClose = (closeCause : DialogCloseCause, value?: string) => void;

interface MultilineStringEditorPopupProps {
    defaultValue? : string
    readOnly : boolean
    userPropertyProps : UserPropertyProps
    onClose : OnClose
}

export const MultilineStringEditorPopup = ({defaultValue, readOnly, userPropertyProps, onClose} : MultilineStringEditorPopupProps) =>
{
    const [value, setValue] = useState(defaultValue);
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();
    const {t:tu} = useTranslation('userproperties');

    // called when the dialog is closed without clicking apply
    const onHideDialog = () => {
        onClose(DialogCloseCause.Cancel);
    }

    const apply = () => {
        onClose(DialogCloseCause.Succes, value);
    }

    return (
        <Modal
            show={true}
            onHide={() => onHideDialog()}
            size="xl"
            fullscreen="lg-down"
            animation={false}
            centered={true}
            contentClassName={"user-property-modal-dialog"}
        >
            <Modal.Header closeButton>
                <Modal.Title>{t(readOnly ? 'user-property.view' : 'user-property.edit')} {tu("userproperty." + userPropertyProps.propertyDetails.userPropertyDetails.name)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputGroup className="mb-3">
                    <Form.Control
                        className="font-monospace white-space-pre"
                        as="textarea"
                        defaultValue={defaultValue ?? ""}
                        onChange={e => setValue(e.target.value)}
                        rows={20}
                        disabled={readOnly}
                        autoFocus
                    />
                </InputGroup>
            </Modal.Body>

            {!readOnly &&
                <Modal.Footer>
                    <Button variant="success" onClick={() => apply()}>
                        {t('user-property.apply')}
                    </Button>
                </Modal.Footer>
            }
        </Modal>
    )
}
